export namespace DriverDetailTabConstants {
  export const RESERVATIONS_TAB: string = 'RESERVATIONS';
  export const VEHICLES_TAB: string = 'VEHICLES';
  export const BANK_TRANSACTIONS_TAB: string = 'BANK_TRANSACTIONS';
  export const NOTES_TAB: string = 'NOTES';
  export const SCREENINGS_TAB: string = 'SCREENINGS';
}
